import { minWidth } from "@mui/system";

export const getStyles = (isRtl, logo) => ({
  aboutUs: {
    padding: '40px 20px',
    maxWidth: '1200px',
    margin: '0 auto',
    textAlign: isRtl ? 'right' : 'left',
    direction: isRtl ? 'rtl' : 'ltr'
  },

  sectionHeader: {
    position: 'relative',
    textAlign: 'center',
    padding: 0,
    marginBottom: '30px',
    background: `url(${logo}) no-repeat center`,
    backgroundSize: '60%',
    backgroundPosition: 'center',
    height: '400px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden'
  },

  sectionHeaderBefore: {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(255, 255, 255, 0.7)',
    zIndex: 1
  },

  sectionHeaderH1: {
    color: 'rgb(154,74,32)',
    fontSize: '3rem',
    marginBottom: '20px',
    position: 'relative',
    zIndex: 2,
    textShadow: '1px 1px 0 rgba(255, 255, 255, 0.8)'
  },

  sectionHeaderH2: {
    color: 'rgb(154,74,32)',
    fontSize: '2.5rem',
    fontWeight: 500,
    marginTop: 0,
    opacity: 0.9,
    position: 'relative',
    zIndex: 2,
    textShadow: '1px 1px 0 rgba(255, 255, 255, 0.8)'
  },

  sectionHeaderHighlight: {
    display: 'block',
    fontSize: '2.5rem',
    fontWeight: 500,
    marginTop: '10px'
  },

  section: {
    marginBottom: '40px'
  },

  aboutUsSection: {
    background: 'none',
    padding: 0,
    boxShadow: 'none'
  },

  h2: {
    color: '#444',
    fontSize: '2rem',
    marginBottom: '20px'
  },

  p: {
    color: '#666',
    lineHeight: 1.5,
    marginBottom: '20px',
    fontSize: '1.1rem'
  },

  benefitsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    marginTop: '20px'
  },

  benefitItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '12px 20px',
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    transition: 'transform 0.2s ease, box-shadow 0.2s ease'
  },

  benefitItemHover: {
    transform: `translateX(${isRtl ? '-5px' : '5px'})`,
    boxShadow: '0 2px 5px rgba(0,0,0,0.15)'
  },

  bullet: {
    color: '#0066cc',
    fontSize: '1.5rem',
    lineHeight: 1
  },

  benefitItemSpan: {
    color: '#444',
    fontSize: '1.1rem'
  },

  ol: {
    paddingLeft: isRtl ? '0' : '20px',
    paddingRight: isRtl ? '20px' : '0',
    margin: '20px 0'
  },

  li: {
    color: '#666',
    padding: '10px 0',
    fontSize: '1.1rem',
    marginLeft: isRtl ? '0' : '15px',
    marginRight: isRtl ? '15px' : '0'
  },

  aboutUsContent: {
    backgroundColor: '#f9f9f9',
    padding: '30px',
    borderRadius: '10px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
  },

  offeringsSection: {
    backgroundColor: '#f9f9f9',
    padding: '30px',
    borderRadius: '10px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
  },

  whyUsSection: {
    backgroundColor: '#f9f9f9',
    padding: '30px 30px 25px',
    borderRadius: '10px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
  },

  card: {
    backgroundColor: '#fff',
    borderRadius: '10px',
    overflow: 'hidden',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    cursor: 'pointer',
    border: '1px solid darkgrey',
    minWidth: '180px'
  },

  image: {
    width: '100%',
    height: '250px',
    objectFit: 'cover',
    borderBottom: '1px solid #eee'
  },

  '@media (max-width: 768px)': {
    sectionHeader: {
      height: '300px',
      backgroundSize: '60%'
    },
    sectionHeaderH1: {
      fontSize: '2.2rem'
    },
    sectionHeaderH2: {
      fontSize: '2rem'
    },
    sectionHeaderHighlight: {
      fontSize: '2rem',
      marginTop: '8px'
    }
  }
});